//
//
//
//
import echarts from 'echarts';
import { debounce } from '@/utils';
export default {
  props: ['chartData'],
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(chartData) {
      var option = {
        backgroundColor: 'rgba(6, 26, 53)',
        //设置背景颜色
        tooltip: {
          trigger: "axis",
          borderColor: "rgba(6, 26, 53)",
          textStyle: {
            color: "#FFF"
          }
        },
        grid: {
          left: "0%",
          top: "10%",
          right: "5%",
          bottom: "15%"
        },
        xAxis: {
          data: ["未处理", "待处理", "已处理"],
          axisLine: {
            show: false,
            //隐藏X轴轴线
            lineStyle: {
              color: "#163a5f",
              width: 2
            }
          },
          axisTick: {
            show: false,
            //隐藏X轴刻度
            alignWithLabel: true
          },
          splitArea: {
            show: false //去掉背景透明白色条纹

          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#BDD8FB",
              //X轴文字颜色
              fontSize: 12
            },
            interval: 0,
            formatter: function formatter(value) {
              var ret = ""; //拼接加\n返回的类目项

              var maxLength = 4; //每项显示文字个数

              var valLength = value.length; //X轴类目项的文字个数

              var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数

              if (rowN > 1) {
                //如果类目项的文字大于5,
                for (var i = 0; i < rowN; i++) {
                  var temp = ""; //每次截取的字符串

                  var start = i * maxLength; //开始截取的位置

                  var end = start + maxLength; //结束截取的位置
                  //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧

                  temp = value.substring(start, end) + "\n";
                  ret += temp; //凭借最终的字符串
                }

                return ret;
              } else {
                return value;
              }
            }
          }
        },
        yAxis: [{
          type: "value",
          name: "",
          nameTextStyle: {
            color: "#BDD8FB",
            fontSize: 12
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(6, 26, 53)" // type: 'dashed', // dotted 虚线

            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            //隐藏X轴轴线
            lineStyle: {
              color: "#163a5f",
              width: 1
            }
          },
          splitArea: {
            show: false //去掉背景透明白色条纹

          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#BDD8FB",
              fontSize: 12
            }
          }
        }, {
          type: "value",
          name: "",
          nameTextStyle: {
            color: "#BDD8FB",
            fontSize: 12
          },
          splitLine: {
            show: false,
            lineStyle: {
              width: 1,
              color: "#CED2DB"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            //隐藏X轴轴线
            lineStyle: {
              color: "#163a5f",
              width: 2
            }
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#797A7F",
              fontSize: 12
            }
          }
        }],
        series: [{
          name: "工单数",
          type: "bar",
          barWidth: 15,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              //右
              y: 0,
              //下
              x2: 0,
              //左
              y2: 1,
              //上
              colorStops: [{
                offset: 0.1,
                color: '#13D5FC' // 0% 处的颜色

              }, {
                offset: 1,
                color: '#2059B8' // 100% 处的颜色

              }]
            },
            barBorderRadius: [20, 20, 20, 20]
          },
          label: {
            show: true,
            position: "top",
            distance: 0,
            color: "#1ACDDC",
            formatter: "{c}" + "单"
          },
          data: chartData
        }]
      };
      this.chart.setOption(option);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myEchart, 'macarons');
      this.setOptions(this.chartData);
    }
  }
};